import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Fourteenththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Urban Mono */
            --primary: #000000;       /* Pure Black */
            --primary-light: #333333; /* Dark Gray */
            --bg-body: #ffffff;       /* Pure White */
            --bg-offset: #f5f5f5;     /* Light Gray */
            --text-main: #1a1a1a;
            --text-muted: #666666;
            --accent: #2563eb;        /* Minimal Blue Accent */

            --font-head: 'Space Grotesk', sans-serif;
            --font-body: 'DM Sans', sans-serif;

            --radius: 0;             /* Sharp corners for brutalist feel */
            --shadow: 4px 4px 0px rgba(0,0,0,1); /* Hard shadow */
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-main);
            background-color: var(--bg-body);
            line-height: 1.6;
        }

        h1, h2, h3, h4, h5 {
            font-family: var(--font-head);
            color: var(--primary);
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: -1px;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.2s;
        }

        .container {
            max-width: 1400px;
            margin: 0 auto;
            padding: 0 40px;
        }

        .section {
            padding: 120px 0;
            border-bottom: 1px solid #000;
        }

        /* Buttons */
        .btn {
            display: inline-block;
            padding: 15px 40px;
            background: var(--primary);
            color: white;
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            border: 2px solid var(--primary);
            box-shadow: var(--shadow);
            transform: translate(-4px, -4px);
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn:hover {
            transform: translate(0, 0);
            box-shadow: none;
            background: white;
            color: black;
        }

        .btn-outline {
            display: inline-block;
            padding: 15px 40px;
            background: white;
            color: black;
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            border: 2px solid var(--primary);
            box-shadow: var(--shadow);
            transform: translate(-4px, -4px);
            cursor: pointer;
            transition: all 0.2s;
        }

        .btn-outline:hover {
            transform: translate(0, 0);
            box-shadow: none;
            background: black;
            color: white;
        }

        /* Nav */
        .navbar {
            padding: 25px 0;
            border-bottom: 2px solid #000;
            position: sticky;
            top: 0;
            background: white;
            z-index: 1000;
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-size: 2rem;
            font-weight: 900;
            letter-spacing: -2px;
        }

        .nav-links {
            display: flex;
            gap: 40px;
        }

        .nav-links a {
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
            font-size: 0.9rem;
        }

        .nav-links a:hover {
            text-decoration: underline;
            text-decoration-thickness: 2px;
        }

        /* Hero */
        .hero {
            min-height: 80vh;
            display: grid;
            grid-template-columns: 1.2fr 0.8fr;
            border-bottom: 2px solid #000;
        }

        .hero-content {
            padding: 100px 40px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-right: 2px solid #000;
            background: var(--bg-offset);
        }

        .hero h1 {
            font-size: 5rem;
            line-height: 0.9;
            margin-bottom: 30px;
        }

        .hero p {
            font-size: 1.4rem;
            margin-bottom: 50px;
            max-width: 600px;
            font-weight: 500;
        }

        .hero-img {
            background: url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80') center/cover;
            filter: grayscale(100%);
        }

        /* Section Items */
        .section-header {
            margin-bottom: 80px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            border-bottom: 4px solid #000;
            padding-bottom: 20px;
        }

        .section-header h2 {
            font-size: 4rem;
            line-height: 1;
        }
        
        .section-tag {
            font-family: var(--font-head);
            font-weight: 700;
            font-size: 1.2rem;
            color: var(--text-muted);
        }

        /* Services Grid */
        .grid-3 {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            border-left: 1px solid #000;
            border-top: 1px solid #000;
        }

        .service-item {
            padding: 60px 40px;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            transition: 0.3s;
        }

        .service-item:hover {
            background: var(--primary);
            color: white;
        }
        
        .service-item:hover h3, .service-item:hover p {
            color: white;
        }

        .service-item h3 {
            font-size: 2rem;
            margin-bottom: 20px;
        }

        .service-pop {
            font-size: 2rem;
            margin-bottom: 20px;
            display: block;
        }
        
        .service-icon-img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            margin-bottom: 20px;
            filter: grayscale(100%);
            border: 2px solid black;
        }
        
        .service-item:hover .service-icon-img {
             border-color: white;
             filter: grayscale(0%);
        }

        /* Products */
        .product-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 20px;
        }

        .product-item {
            border: 2px solid #000;
            padding: 20px;
        }

        .product-visual {
            aspect-ratio: 1/1;
            background: #eee;
            margin-bottom: 20px;
            border: 1px solid #000;
            overflow: hidden;
        }
        
        .product-visual img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: grayscale(100%);
            transition: 0.3s;
        }
        
        .product-item:hover .product-visual img {
            filter: grayscale(0%);
            transform: scale(1.05);
        }

        .product-meta {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 15px;
        }

        .product-meta h3 {
            font-size: 1.1rem;
            max-width: 70%;
        }
        
        .price-tag {
            font-weight: 700;
            font-family: var(--font-head);
            background: black;
            color: white;
            padding: 2px 8px;
        }

        .product-btn {
            width: 100%;
            padding: 12px;
            background: white;
            border: 2px solid black;
            font-weight: 700;
            cursor: pointer;
            text-transform: uppercase;
        }
        
        .product-btn:hover {
            background: black;
            color: white;
        }

        /* Reviews */
        .review-strip {
            display: flex;
            overflow-x: auto;
            border-top: 2px solid black;
            border-bottom: 2px solid black;
        }

        .review-block {
            min-width: 500px;
            padding: 60px;
            border-right: 2px solid black;
            background: var(--bg-offset);
        }

        .review-content {
            font-size: 1.5rem;
            font-weight: 500;
            line-height: 1.4;
            margin-bottom: 30px;
        }

        .performer {
            font-family: var(--font-head);
            font-weight: 700;
            text-transform: uppercase;
        }

        /* Footer */
        footer {
            background: black;
            color: white;
            padding: 100px 0 40px;
        }

        .footer-flex {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            gap: 60px;
        }

        .footer-brand {
            font-size: 5rem;
            font-family: var(--font-head);
            line-height: 0.8;
            margin-bottom: 40px;
            display: block;
        }

        .footer-group h4 {
            color: white;
            margin-bottom: 20px;
            font-size: 1.2rem;
        }

        .footer-group ul li {
            margin-bottom: 10px;
        }

        .footer-group a:hover {
            text-decoration: underline;
        }

        @media (max-width: 900px) {
            .hero { grid-template-columns: 1fr; }
            .hero-content { border-right: none; border-bottom: 2px solid #000; }
            .grid-3 { grid-template-columns: 1fr; }
            .product-list { grid-template-columns: 1fr 1fr; }
            .footer-brand { font-size: 3rem; }
            .nav-links { display: none; }
        }
    `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Space+Grotesk:wght@400;500;700&display=swap" rel="stylesheet" />

            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#about">About</a>
                        <a href="#services">Architecture</a>
                        <a href="#products">Inventory</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </nav>

            <header className="hero">
                <div className="hero-content">
                    <h1>Defined.<br/>Refined.<br/>Aligned.</h1>
                    <p>We strip away the non-essential to reveal the core of excellence. Pure function meets bold form.</p>
                    <div style={{display: 'flex', gap: '20px'}}>
                        <a href="#products" className="btn">View Catalog</a>
                        <a href="#contact" className="btn-outline">Get in Touch</a>
                    </div>
                </div>
                <div className="hero-img"></div>
            </header>

            <section className="section" id="about">
                <div className="container">
                    <div className="section-header">
                        <h2>The Mission</h2>
                        <span className="section-tag">01</span>
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '60px'}}>
                        <p style={{fontSize: '1.5rem', fontWeight: 500}}>
                            {get_data.service_name} operates at the intersection of utility and aesthetics. We don't just provide services; we engineer experiences.
                        </p>
                        <div>
                            <p style={{marginBottom: '20px'}}>
                                Our philosophy is simple: cut the noise. In a world of clutter, we offer clarity. Every product found in our inventory and every service we render is curated for maximum impact.
                            </p>
                            <ul style={{fontFamily: 'var(--font-head)', fontWeight: 700, fontSize: '1.2rem'}}>
                                <li>— Precision in Execution</li>
                                <li>— Transparency in Pricing</li>
                                <li>— Integrity in Action</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section" id="services" style={{padding: '0', borderBottom: '2px solid black'}}>
                <div className="container" style={{padding: '80px 40px'}}>
                    <div className="section-header" style={{marginBottom: '40px', borderBottom: 'none'}}>
                         <h2>Capabilities</h2>
                         <span className="section-tag">02</span>
                    </div>
                </div>
                <div className="grid-3">
                     {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="service-item" key={index}>
                            <div className="service-pop">
                                {item.icon ? (
                                    <img 
                                        src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                        alt={item.name}
                                        className="service-icon-img"
                                    />
                                ) : (
                                    <span>⊕</span>
                                )}
                            </div>
                            <h3>{item.name}</h3>
                            <p>{item.description || 'Service specification loading...'}</p>
                            <div style={{marginTop: '30px', display: 'flex', gap: '15px'}}>
                                 <a href={`tel:${get_data.mobile}`} style={{textDecoration: 'underline', fontWeight: 700}}>Call Now</a>
                                 <a href="#contact" style={{textDecoration: 'underline', fontWeight: 700}}>Enquire</a>
                            </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            </section>

            <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <h2>Inventory</h2>
                        <span className="section-tag">03</span>
                    </div>
                    <div className="product-list">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-item" key={index}>
                                <div className="product-visual">
                                     {item.featured_image ? (<img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                    />) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                </div>
                                <div className="product-meta">
                                    <h3>{item.service_name}</h3>
                                    {item.price && <span className="price-tag">₹{item.price}</span>}
                                </div>
                                <p style={{fontSize: '0.85rem', marginBottom: '20px', color: '#666'}}>{item.description || 'Standard Specification'}</p>
                                <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                    <button onClick={() => addToCart(item)} className="product-btn">Add to Cart</button>
                                    <div style={{display: 'flex', gap: '10px'}}>
                                        <a href={`tel:${get_data.mobile}`} style={{flex: 1, textAlign: 'center', fontWeight: 700, fontSize: '0.8rem', border: '1px solid black', padding: '8px'}}>CALL</a>
                                        <a href="#contact" style={{flex: 1, textAlign: 'center', fontWeight: 700, fontSize: '0.8rem', border: '1px solid black', padding: '8px'}}>ASK</a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="section" id="categories">
                <div className="container">
                    <div className="section-header">
                        <h2>Categories</h2>
                        <span className="section-tag">04</span>
                    </div>
                    <div className="grid-3" style={{borderLeft: 'none', borderTop: 'none', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px'}}>
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                            <div key={index} className="product-item" style={{display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center'}}>
                                {cat.icon ? (
                                    <img src={cat.icon.startsWith('http') ? cat.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${cat.icon}`} 
                                         style={{width: '80px', height: '80px', objectFit: 'contain', marginBottom: '20px', filter: 'grayscale(100%)', border: '2px solid black', padding: '10px'}} alt={cat.name} />
                                ) : (
                                    <div style={{width: '80px', height: '80px', background: '#eee', margin: '0 0 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', border: '2px solid black'}}>
                                        {(cat.name || 'C').charAt(0)}
                                    </div>
                                )}
                                <h3 style={{fontSize: '1.5rem', marginBottom: '20px'}}>{cat.name}</h3>
                                <div style={{display: 'flex', gap: '10px', width: '100%'}}>
                                    <a href={`tel:${get_data.mobile}`} className="product-btn" style={{flex: 1, padding: '10px', fontSize: '0.8rem'}}>Call</a>
                                    <a href="#contact" className="product-btn" style={{flex: 1, padding: '10px', fontSize: '0.8rem'}}>Ask</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            <section className="section" style={{padding: '0', borderBottom: 'none'}}>
                <div className="container" style={{padding: '80px 40px'}}>
                    <div className="section-header">
                        <h2>Feedback</h2>
                        <span className="section-tag">05</span>
                    </div>
                </div>
                <div className="review-strip">
                     {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                         get_data.review_ratings.map((review, index) => (
                            <div className="review-block" key={index}>
                                <p className="review-content">"{review.review || 'No comment provided.'}"</p>
                                <div className="performer">
                                    — {review.user_name || 'Anonymous'}
                                    {review.rating && <span style={{marginLeft: '15px'}}>{'★'.repeat(Math.round(review.rating))}</span>}
                                </div>
                            </div>
                        ))
                     ) : (
                         <div className="review-block"><p>No data.</p></div>
                     )}
                </div>
            </section>

            <footer id="contact">
                <div className="container">
                    <span className="footer-brand">{get_data.service_name}</span>
                    <div className="footer-flex">
                        <div className="footer-group">
                            <h4>Reach Out</h4>
                            <ul>
                                <li>{get_data.business_location_name}</li>
                                <li>{get_data.email}</li>
                                <li>{get_data.mobile}</li>
                            </ul>
                        </div>
                        <div className="footer-group">
                            <h4>Sitemap</h4>
                            <ul>
                                <li><a href="#">Home</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#services">Services</a></li>
                                <li><a href="#products">Products</a></li>
                            </ul>
                        </div>
                        <div className="footer-group">
                            <h4>Social</h4>
                            <ul>
                                {get_data.facebook && <li><a href={get_data.facebook}>Facebook</a></li>}
                                {get_data.twitter && <li><a href={get_data.twitter}>Twitter</a></li>}
                                {get_data.instagram && <li><a href={get_data.instagram}>Instagram</a></li>}
                            </ul>
                        </div>
                    </div>
                    <div style={{marginTop: '80px', borderTop: '1px solid #333', paddingTop: '30px', fontSize: '0.8rem', color: '#666'}}>
                        © {new Date().getFullYear()} {get_data.service_name}. All rights reserved.
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Fourteenththeme;
